import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { dataGridTextSorter } from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { Spinner } from '../../../../common/index.jsx';
import { IconButton } from '../../../../common/controls/Controls.jsx';
import {
  CreditCardOutlined,
  HddOutlined,
  RedoOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';

const YellowBooksTable = ({
  yellowBooks,
  isArchived,
  onDelete,
  onDetailClick,
  onSectionClick,
  onArchiveClick,
  onActivateClick,
}) => {
  const { t } = useTranslation();
  const titleSkTextFilterProps = useDataGridTextFilter('title');
  const titleEnTextFilterProps = useDataGridTextFilter('title_en');

  const customSettings = (projectRow) => {
    return (
      <div style={{ display: 'flex' }}>
        <IconButton
          icon={<HddOutlined />}
          tooltip={t('Editovať sekcie')}
          onClick={(e) => {
            e.stopPropagation();
            onSectionClick(projectRow);
          }}
        />
        {!isArchived && (
          <IconButton
            icon={<CreditCardOutlined />}
            tooltip={t('Archivovať')}
            onClick={(e) => {
              e.stopPropagation();
              onArchiveClick(projectRow);
            }}
          />
        )}
        {isArchived && (
          <IconButton
            icon={<RedoOutlined />}
            tooltip={t('Obnoviť')}
            onClick={(e) => {
              e.stopPropagation();
              onActivateClick(projectRow);
            }}
          />
        )}
      </div>
    );
  };

  const columns = useMemo(
    () => [
      {
        title: t('Názov'),
        dataIndex: 'title',
        ellipsis: true,
        sorter: dataGridTextSorter('title'),
        defaultSortOrder: 'ascend',
        ...titleSkTextFilterProps,
      },
      {
        title: t('Názov (anglicky)'),
        dataIndex: 'title_en',
        ellipsis: true,
        sorter: dataGridTextSorter('title_en'),
        ...titleEnTextFilterProps,
      },
      {
        title: t('Status'),
        dataIndex: 'state',
        ellipsis: true,
        render: (_, row) => (
          <Tag color={!row.archived_at ? 'green' : 'red'}>
            {!row.archived_at ? 'Aktívna' : 'Archivovaná'}
          </Tag>
        ),
      },
    ],
    [t, titleSkTextFilterProps, titleEnTextFilterProps],
  );

  if (!yellowBooks) {
    return <Spinner />;
  }

  return (
    <DataGrid
      rowKey={(book) => book.id}
      columns={columns}
      dataSource={yellowBooks || []}
      permissionsBasic={'yellow-books'}
      customSettings={customSettings}
      optionsWidth={200}
      onEditClick={onDetailClick}
      onRowClick={onDetailClick}
      onDelete={onDelete}
    />
  );
};

YellowBooksTable.propTypes = {
  yellowBooks: PropTypes.array,
  isArchived: PropTypes.bool,
  showArchive: PropTypes.bool,
  onDelete: PropTypes.func,
  onDetailClick: PropTypes.func,
  onCreateClick: PropTypes.func,
  onSectionClick: PropTypes.func,
  onArchiveClick: PropTypes.func,
  onActivateClick: PropTypes.func,
};

export default YellowBooksTable;
